import FaqList from './js/FaqList';
import './faq.css';

export default FaqList;
